export const CLASS_NAMES = {
  OVERLAY: "js-overlay",
};
